import React from 'react';

export function FermentationTypes() {
  return (
    <div className="space-y-6 text-white/90" style={{ userSelect: "none" }}>
      <div className="bg-gray-600/60 p-6">
        <h3 className="text-xl text-white mb-4">Different Types of Ferments</h3>
        <p className="mb-4">
          Understanding different fermentation types helps you choose the best approach for your bread and schedule. Each method has unique characteristics that affect flavor, texture, and timing.
        </p>
        
        <div className="space-y-4">
          <div className="border-l-4 border-amber-400 pl-4">
            <h4 className="font-medium">When to Choose Sourdough</h4>
            <ul className="list-disc list-inside text-sm text-white/80 mt-2">
              <li>For complex, tangy flavors</li>
              <li>When longer fermentation is desired</li>
              <li>For better digestibility</li>
              <li>To preserve traditional baking methods</li>
              <li>For unique flavor profiles</li>
            </ul>
          </div>
          
          <div className="border-l-4 border-amber-400 pl-4">
            <h4 className="font-medium">When to Choose Commercial Yeast</h4>
            <ul className="list-disc list-inside text-sm text-white/80 mt-2">
              <li>For faster baking timelines</li>
              <li>When milder flavor is preferred</li>
              <li>For enriched doughs with added fats, sugars, and eggs</li>
              <li>For beginners learning bread basics</li>
            </ul>
          </div>
          
          <div className="border-l-4 border-amber-400 pl-4">
            <h4 className="font-medium">When to Choose Hybrid Methods</h4>
            <ul className="list-disc list-inside text-sm text-white/80 mt-2">
              <li>When transitioning from commercial yeast to sourdough</li>
              <li>For more reliable results with some sourdough character</li>
              <li>When time is limited but flavor is important</li>
              <li>For using up sourdough discard</li>
              <li>For experimenting with different flavor profiles</li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="bg-gray-600/60 p-6">
        <h3 className="text-xl text-amber-400 mb-4">Practical Tips for Different Fermentation Types</h3>
        
        <div className="space-y-4">
          <div>
            <h4 className="text-lg text-white mb-2">For Sourdough Fermentation</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Maintain your starter at peak activity for best results</li>
              <li>Use warmer temperatures (75-80°F/24-27°C) for more acetic acid (sharper tang)</li>
              <li>Use cooler temperatures (65-70°F/18-21°C) for more lactic acid (milder tang)</li>
              <li>Higher hydration promotes bacterial activity and acidity</li>
              <li>Judge fermentation by dough behavior, not just time</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg text-white mb-2">For Commercial Yeast</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Use 2-2.5% fresh yeast or 0.8-1% dry yeast (baker's percentage)</li>
              <li>Instant yeast can be mixed directly with flour</li>
              <li>Active dry yeast should be rehydrated in warm water (100-110°F/38-43°C)</li>
              <li>Salt and sugar in high concentrations can inhibit yeast activity</li>
              <li>Warmer dough temperatures speed up fermentation</li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-lg text-white mb-2">For Hybrid Methods</h4>
            <ul className="list-disc list-inside text-sm text-white/80 space-y-1">
              <li>Start with a small percentage of sourdough starter (10-20% of flour weight)</li>
              <li>Reduce commercial yeast by about half when using with sourdough</li>
              <li>Pre-ferments like poolish or biga can add complexity without a full sourdough commitment</li>
              <li>For best flavor, allow at least 4 hours of fermentation even with commercial yeast</li>
              <li>Refrigeration can extend fermentation time and develop flavor</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}